import React from 'react'
import { connect } from 'react-redux'
import { Box, Flex } from 'reflexbox'
import * as BP from '@blueprintjs/core'
import {
    getActivityLogs,
    getAllActivityLogsFromServer,
    updateActivityLog,
} from 'src/store/modules/runbooks'
import { bindActionCreators } from 'redux'
import AddActivityDialog from 'src/routes/Runbook/Controls/Dialogs/AddActivityDialog'

const classNamePrefix = 'runbooks-issue-logs'

class ActivityLogs extends React.Component {
    state = {
        editingLog: null,
    }

    componentDidMount() {
        this.props.actions.getAllActivityLogsFromServer(this.props.session)
    }

    handleEditActivityClick(log) {
        this.setState({ editingLog: log })
    }

    handleEditActivityClose(log) {
        this.setState({ editingLog: null })
    }

    renderActivityLogs() {
        return this.props.activityLogs.map((log) => (
            <BP.Card key={log.id} interactive elevation={BP.Elevation.TWO}>
                <Flex>
                    <Box w={1 / 5}>
                        <div className={`${classNamePrefix}_tag-container`}>
                            <span className="uid">
                                {log.action ? (
                                    <BP.Tag>{log.action.uid}</BP.Tag>
                                ) : null}
                            </span>
                            <span className="action-name">
                                {log.action ? (
                                    <BP.Tag intent={log.action ? 'danger' : ''}>
                                        {log.action.name}
                                    </BP.Tag>
                                ) : null}
                            </span>
                        </div>
                    </Box>
                    <Box w={3 / 5}>
                        <div className={`${classNamePrefix}_content-container`}>
                            <Flex justify="space-between">
                                <Box w={1 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Status:
                                        </span>
                                        {
                                            this.props.statusChoices.find(
                                                (choice) =>
                                                    choice[0] === log.status
                                            )[1]
                                        }
                                    </span>
                                </Box>
                                <Box w={1 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Priority:
                                        </span>
                                        {
                                            this.props.priorityChoices.find(
                                                (choice) =>
                                                    choice[0] === log.priority
                                            )[1]
                                        }
                                    </span>
                                </Box>
                                <Box w={2 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Owner:
                                        </span>
                                        {log.owner}
                                    </span>
                                </Box>
                                <Box w={2 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Company:
                                        </span>
                                        {log.company}
                                    </span>
                                </Box>
                                <Box w={2 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Source:
                                        </span>
                                        {log.source}
                                    </span>
                                </Box>
                                <Box w={4 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Description:
                                        </span>
                                        {log.description}
                                    </span>
                                </Box>
                                <Box w={3 / 12}>
                                    <span
                                        className={`${classNamePrefix}_field`}
                                    >
                                        <span
                                            className={`${classNamePrefix}_field-label`}
                                        >
                                            Comments:
                                        </span>
                                        {log.comments}
                                    </span>
                                </Box>
                            </Flex>
                        </div>
                    </Box>
                    <Box w={1 / 5} style={{ textAlign: 'right' }}>
                        <span className="created-at">{log.createdAt}</span>
                        <BP.Button
                            style={{ margin: 'auto 0 auto 0' }}
                            icon="edit"
                            onClick={() => {
                                this.handleEditActivityClick(log)
                            }}
                        />
                    </Box>
                </Flex>
            </BP.Card>
        ))
    }

    renderAddActivityDialog() {
        let {
            id,
            source,
            date,
            description,
            owner,
            company,
            priority,
            status,
            due,
            comments,
            closed,
            action,
        } = this.state.editingLog
        return (
            <AddActivityDialog
                id={id}
                source={source}
                date={date}
                description={description}
                owner={owner}
                company={company}
                priority={priority}
                status={status}
                due={due}
                comments={comments}
                closed={closed}
                fromAction={(action && action.uid) || null}
                handleConfirm={(data) => {
                    this.props.actions.updateActivityLog(
                        this.props.session,
                        data
                    )
                }}
                handleClose={() => {
                    this.handleEditActivityClose()
                }}
            />
        )
    }

    render() {
        if (!this.props.activityLogs) return null
        let activityLogs = this.renderActivityLogs()
        let addActivityDialog = this.state.editingLog
            ? this.renderAddActivityDialog()
            : null
        return (
            <div className={classNamePrefix}>
                {activityLogs}
                {addActivityDialog}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    activityLogs: getActivityLogs(state),
    isEditingActivity: state.ui.runbook.controls.isInsertingActivity,
    priorityChoices: state.app.activityLogPriorities,
    statusChoices: state.app.activityLogStatuses,
})

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatch,
        actions: bindActionCreators(
            {
                updateActivityLog,
                getAllActivityLogsFromServer,
            },
            dispatch
        ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityLogs)
